/*!

=========================================================
* Paper Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useEffect} from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
} from "reactstrap";

import logo from "assets/img/aotm.png";


function AuthNavbar({ location, transparent }) {

  const registerLinks = (location) => {
    if (location === "/auth/login") {
      return (
        <NavLink to="/auth/register" className="nav-link">
          <i className="nc-icon nc-book-bookmark" />{" "}
          Zarejestruj
        </NavLink>
      )
    } else if (location === "/auth/register") {
      return (
        <NavLink to="/auth/login" className="nav-link">
          <i className="nc-icon nc-key-25" />{" "}
          Zaloguj
        </NavLink>
      )
    }
  }
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [color, setColor] = React.useState("bg-white");
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened

  useEffect(() => {
    if (transparent) {
      setColor("navbar-transparent");
    }
  }, [transparent]);

  const toggleCollapse = () => {
    if (!collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
    setCollapseOpen(!collapseOpen);
  };

  return (
    <Navbar
      className={classnames(" fixed-top", color)}
      expand="lg"
    >
      <Container>
        <div className="navbar-wrapper">
          <NavbarBrand
          // onClick={(e) => e.preventDefault()}
          >
            <div className="logo">
              <a
                href="\"
                className="simple-text logo-mini"
              >
                <div className="logo-img">
                  <img src={logo} alt="logo-normal" width='50px'/>
                </div>
              </a>
            </div>
          </NavbarBrand>
        </div>
        <button
          aria-controls="navigation-index"
          aria-expanded={false}
          aria-label="Toggle navigation"
          className="navbar-toggler"
          data-toggle="collapse"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </button>
        <Collapse isOpen={collapseOpen} className="justify-content-end" navbar>
          <Nav navbar>
            <NavItem>
              {registerLinks(location)}
              {/* <NavLink to="/auth/register" className="nav-link">
                <i className="nc-icon nc-book-bookmark" />
                Register
              </NavLink> */}
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default AuthNavbar;
